module.exports = __webpack_public_path__ + "static/restaurant-3070e2f0c22b105f9fab8ea4d7b1cbc9.jpg";